"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagLink = void 0;
var react_1 = __importDefault(require("react"));
var getTypoComp_1 = require("../../utils/getTypoComp");
var styled_1 = require("./styled");
/**
 * @component Renders a TagLink component with customizable text, URL, style and variant.
 *
 * - The props object containing the following properties:
 * @prop {string} display: The text to be displayed inside the TagLink component.
 * @prop {string} to: The URL to navigate to when the component is clicked.
 * @prop {boolean} [invert] : A boolean indicating whether to invert the colors of the component. Defaults to false.
 * @prop {boolean} [M] : A boolean indicating whether the component should render at the large size. Defaults to false.
 * @prop {boolean} [XS] : A boolean indicating whether the component should render at the extra small size. Defaults to false.
 * @prop {string} [variant] : A string indicating the variant of the component. Defaults to "primary".
 * @prop {string} [color] : A string indicating the background color of the component. Defaults to undefined.
 * @return {ReactElement} The rendered TagLink component.
 */
var TagLink = function (_a) {
    var display = _a.display, to = _a.to, invert = _a.invert, M = _a.M, XS = _a.XS, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, color = _a.color;
    var size = M ? 'M' : XS ? 'XS' : 'S';
    var TYPO_COMP = (0, getTypoComp_1.getTypoComp)(size);
    return (react_1.default.createElement(styled_1.StyledLink, { to: to },
        react_1.default.createElement(styled_1.StyledTagLink, { color: color, variant: variant, invert: invert, size: size },
            react_1.default.createElement(TYPO_COMP, null, display))));
};
exports.TagLink = TagLink;
